import { UseQueryResult } from '@tanstack/react-query';
import { Table, Tag, Typography } from 'antd';
import { ColumnsType } from 'antd/es/table';
import { AxiosResponse } from 'axios';
import { TFunction } from 'i18next';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import urlPath from 'src/constants/urlPath';
import { TicketStatus } from 'src/types/helpdesk/ticket.type';
import { IPurchaseRequestTicket } from 'src/types/hr_ticket/purchaseRequestTicket.type';
import { formatDateTime } from 'src/utils/utils';
const { Text } = Typography;

const columnsPurchaseRequestTicket = function (
  t: TFunction<'translation', undefined, 'translation'>
): ColumnsType<IPurchaseRequestTicket> {
  const columnTitle: ColumnsType<IPurchaseRequestTicket> = [
    {
      title: t('columnTitle.purchaseRequestTicket.code'),
      dataIndex: 'code',
      key: 'code',
      render: (_, record) => <Link to={`${urlPath.myPurchaseRequestTicket.location}/${record.id}`}>{record.code}</Link>
    },
    {
      title: t('columnTitle.purchaseRequestTicket.ticketStatus'),
      dataIndex: 'ticketStatus',
      key: 'ticketStatus',
      render: (_, record) => {
        if (record.ticketStatusId === TicketStatus.ApprovedRequest) {
          return <Tag color='success'>{record?.ticketStatus.name}</Tag>;
        } else if (record.ticketStatusId === TicketStatus.Reject) {
          return <Tag color='volcano'>{record?.ticketStatus.name}</Tag>;
        } else if (record.ticketStatusId === TicketStatus.Canceled) {
          return <Tag color='warning'>{record?.ticketStatus.name}</Tag>;
        }
        return <Tag color='blue'>{record?.ticketStatus.name}</Tag>;
      }
    },
    {
      title: t('columnTitle.base.createdDate'),
      dataIndex: 'createdDate',
      key: 'createdDate',
      sorter: true,
      render: (_, record) => formatDateTime(record?.createdDate)
    },
    {
      title: t('columnTitle.purchaseRequestTicket.createdBy'),
      dataIndex: 'createdBy',
      key: 'createdBy',
      render: (_, record) => record?.createdBy?.fullName
    },
    {
      title: t('columnTitle.purchaseRequestTicket.erpKey'),
      dataIndex: 'erpKey',
      key: 'erpKey',
      render: (_, record) => record?.erpKey
    }
  ];

  return columnTitle;
};

export default function PurchaseRequestTicket(
  refPurchaseRequestTicketsForTicketQuery: UseQueryResult<AxiosResponse<IPurchaseRequestTicket[], any>, unknown>
) {
  const { t } = useTranslation();
  return (
    <Table
      title={(record) => (
        <Text strong keyboard>
          {t('card.overtimeTicket')}
        </Text>
      )}
      style={{ marginBottom: 25 }}
      columns={columnsPurchaseRequestTicket(t)}
      rowKey={(record) => record.code}
      dataSource={refPurchaseRequestTicketsForTicketQuery.data?.data}
      scroll={{ x: 400 }}
      pagination={false}
      // expandable={{
      //   expandedRowRender: (record) => (
      //     <Descriptions size='small' column={2}>
      //       <Descriptions.Item label={t('columnTitle.overtimeTicket.note')}>{record.note}</Descriptions.Item>
      //     </Descriptions>
      //   ),
      //   rowExpandable: (record) => record.note.length > 0
      // }}
      bordered
      size='middle'
    />
  );
}
